import Typography from '@mui/material/Typography';
import { SelectMultipleFieldYears } from '../../../../../FormControl/SelectRequest/SelectMultipleFieldYears';
import AutocompleteField from '../../../../../FormControl/input/AutocompleteField';
import { Divider, FormHelperText } from '@mui/material';
import FormPreviousPR from './FormPreviousPR';
import FormDataCode from './FormDataCode';

const FormBasicInformation = ({
  errorAssessmentAreas,
  optionsAssessmentAreas,
  isLoadingAssessmentAreas,
  currentCurriculum,
  form = {},
  onChange,
  errors = {},
  type,
  loading,
  curriculum
}) => {
  return (
    <>
      <div className='grid grid-cols-4 items-center gap-4 py-4 px-4'>
        <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
          Year level
        </Typography>
        <div className='col-span-3'>
          <SelectMultipleFieldYears
            id='yearLevelId'
            name='yearLevelId'
            value={form?.yearLevelId || []}
            error={errors?.yearLevelId}
            helperText={errors?.yearLevelId}
            onChange={(e) => onChange('yearLevelId', e.target.value)}
            isPreview={type === 'preview' || loading}
          />
        </div>
        <Divider className='col-span-full' />
        <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
          Code
        </Typography>
        <div className='col-span-3'>
          {type === 'preview' ? (
            <Typography>
              {form?.assessmentData?.code} - {form?.assessmentData?.name}
            </Typography>
          ) : (
            <>
              <AutocompleteField
                id='code-assessment-area'
                name='codeSelected'
                placeholder='Select a code'
                value={form.codeSelected}
                onChange={(e) => onChange('codeSelected', e)}
                options={optionsAssessmentAreas || []}
                error={errorAssessmentAreas || errors?.codeSelected}
                loading={isLoadingAssessmentAreas}
                disabled={loading}
                groupBy={(option) => option?.curriculum}
              />
              {errors?.codeSelected && (
                <FormHelperText error={!!errors?.codeSelected}>{errors?.codeSelected}</FormHelperText>
              )}
            </>
          )}
        </div>
        {form?.assessmentData && (
          <FormDataCode currentCurriculum={currentCurriculum} form={form?.assessmentData || {}} />
        )}
      </div>
      <FormPreviousPR
        form={form}
        errors={errors}
        onChange={onChange}
        type={type}
        loading={loading}
        curriculum={curriculum}
      />
    </>
  );
};

export default FormBasicInformation;
